import type { ApiTraining, ApiTrainingItem, GenericHttpResult } from '@agunity/api-v4';

import { apiService } from '../../api/apiService';

export const getTrainings = (userId: number) => {
  return async (): Promise<GenericHttpResult<ApiTrainingItem[]>> => {
    const response = await apiService.trainingV10TopicsCoveredDetail(userId);
    return response;
  };
};

export const getTrainingItem = (userId: number, trainingTopicId: number) => {
  return async (): Promise<GenericHttpResult<ApiTraining>> => {
    const response = await apiService.trainingV10V10TrainingTopicDetail(userId, trainingTopicId);
    return response;
  };
};